import script from "./RadiogroupElement.vue?vue&type=script&lang=js"
export * from "./RadiogroupElement.vue?vue&type=script&lang=js"

import "./RadiogroupElement.vue?vue&type=style&index=0&id=ed0c7de8&lang=scss"

const __exports__ = script;

export default __exports__